export const InternetConnection = () => {
    if (navigator.onLine) {
        return true
    }
    return false
}